function createOverlay(image) {
  const overlay = document.createElement('div');

  overlay.className = 'image-magnify-full-size';
  overlay.setAttribute('aria-hidden', 'true');

  // Use already loaded image directly
  overlay.style.backgroundImage = `url("${image.currentSrc || image.src}")`;
  overlay.style.backgroundColor = 'var(--gradient-background)';

  // Insert immediately — no image.onload waiting
  image.parentElement.insertBefore(overlay, image);

  return overlay;
}

function moveWithHover(image, event, zoomRatio, overlay) {
  const rect = overlay.getBoundingClientRect();

  const x = event.clientX - rect.left;
  const y = event.clientY - rect.top;

  const xPercent = (x / rect.width) * 100;
  const yPercent = (y / rect.height) * 100;

  overlay.style.backgroundPosition = `${xPercent}% ${yPercent}%`;

  // Use rendered size for consistent zoom
  overlay.style.backgroundSize =
    `${image.clientWidth * zoomRatio}px auto`;
}

function magnify(image, zoomRatio, event) {
  // Avoid duplicate overlay
  if (image.parentElement.querySelector('.image-magnify-full-size')) {
    return;
  }

  const overlay = createOverlay(image);

  // Show correct position immediately
  moveWithHover(image, event, zoomRatio, overlay);

  overlay.addEventListener('mousemove', (event) => {
    moveWithHover(image, event, zoomRatio, overlay);
  });

  overlay.addEventListener('mouseleave', () => {
    overlay.remove();
  });
}

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');

  images.forEach((image) => {
    image.addEventListener('mouseenter', (event) => {
      magnify(image, zoomRatio, event);
    });
  });
}

enableZoomOnHover(2);